import { GeneralApiResponse } from '../models/general-api-response';

export const getApiErrorMessage = (
  error: unknown,
  fallback = 'Ocurrió un error inesperado'
): string => {
  // Handle error from HttpErrorResponse
  const err = error as any;

  if (err?.error) {
    return (
      err.error?.apiError?.messageUser || err.error?.messageUser || err.error?.message || fallback
    );
  }

  // Handle error from success = false
  const response = error as GeneralApiResponse;

  if (response?.success === false) {
    return response.apiError?.messageUser || response.messageUser || response.message || fallback;
  }

  return fallback;
};
